import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BazowyComponent } from 'src/app/komponenty/bazowy.component';
import { KolumnaDoRaportu } from 'src/app/modele/projekty/arkuszSpisu/kolumnaDoRaportu';
import { PobierzDaneDoGenerowaniaRaportuModel } from 'src/app/modele/projekty/arkuszSpisu/pobierzDaneDoGenerowaniaRaportuModel';
import { PobierzDaneDoWyboruRaportuModel } from 'src/app/modele/projekty/arkuszSpisu/pobierzDaneDoWyboruRaportuModel';
import { PobierzDaneDoWyboruRaportuRezultat } from 'src/app/modele/projekty/arkuszSpisu/pobierzDaneDoWyboruRaportuRezultat';
import { PomieszczenieDoArkusza } from 'src/app/modele/projekty/arkuszSpisu/pomieszczenieDoArkusza';
import { RodzajRaportu } from 'src/app/modele/projekty/arkuszSpisu/rodzajRaportu';
import { WygenerujArkuszModel } from 'src/app/modele/projekty/arkuszSpisu/wygenerujArkuszModel';
import { ZapiszSzerokosciKolumnModel } from 'src/app/modele/projekty/arkuszSpisu/zapiszSzerokosciKolumnModel';
import { IdModel } from 'src/app/modele/wspolne/id.model';
import { Routing } from 'src/app/modele/wspolne/routing';
import { AuthService } from 'src/app/serwisy/ogolne/auth.service';
import { LoaderService } from 'src/app/serwisy/ogolne/loader.service';
import { ArkuszSpisuService } from 'src/app/serwisy/projekty/arkusz-spisu.service';

@Component({
  selector: 'app-generowanie-arkusza-spisu',
  templateUrl: './generowanie-arkusza-spisu.component.html',
  styleUrls: ['./generowanie-arkusza-spisu.component.css'],
})
export class GenerowanieArkuszaSpisuComponent
  extends BazowyComponent
  implements OnInit
{
  idProjektu: string;
  idLokalizacji: string;
  idPomieszczenia: string;
  miejsceWywolania: string;
  czyZaladowanoDane: boolean;
  adresLokalizacji: string;
  daneDoEkranu: PobierzDaneDoWyboruRaportuRezultat =
    new PobierzDaneDoWyboruRaportuRezultat();
  model: WygenerujArkuszModel = new WygenerujArkuszModel();
  czyCalaLokalizacja: boolean;
  czyPokazanoPodmenu: boolean;
  czySpisSamodzielnyKlienta: boolean = false;
  rodzajRaportu = RodzajRaportu;
  // szerokości wpisane ręcznie lub zapisane w projekcie (nazwa kolumny -> %), także dla kolumn niezaznaczonych
  szerokosciReczne = new Map<string, number>();
  // kolejność ustawiania ręcznych szerokości (najstarsza pierwsza) - przy braku miejsca najstarsze ustępują
  kolejnoscRecznych: Array<string> = [];
  // ręczne kolumny, których wartość jest aktualnie zastosowana
  efektywneReczne = new Set<string>();

  constructor(
    public router: Router,
    modalService: NgbModal,
    loaderSerwis: LoaderService,
    komunikatSerwis: ToastrService,
    public authService: AuthService,
    public arkuszSpisuSerwis: ArkuszSpisuService,
    public translateSerwis: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {
    super(
      authService,
      modalService,
      loaderSerwis,
      komunikatSerwis,
      router,
      translateSerwis
    );
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.idLokalizacji =
        this.activatedRoute.snapshot.paramMap.get('idLokalizacji');
      this.idProjektu = this.activatedRoute.snapshot.paramMap.get('idProjektu');
      this.idPomieszczenia =
        this.activatedRoute.snapshot.paramMap.get('idPomieszczenia');
      this.miejsceWywolania =
        this.activatedRoute.snapshot.paramMap.get('miejsceWywolania');

      this.model = history.state.data;

      if (this.model == undefined) {
        if (this.idPomieszczenia) {
          this.router.navigate([
            Routing.WyborRaportu,
            this.idProjektu,
            this.idLokalizacji,
            this.idPomieszczenia,
          ]);
        } else {
          this.router.navigate([
            this.miejsceWywolania,
            Routing.WyborRaportu,
            this.idProjektu,
            this.idLokalizacji,
          ]);
        }
        return;
      }

      this.pobierzDaneDoEkranu();
    });
  }

  pobierzDaneDoEkranu() {
    var model = new PobierzDaneDoGenerowaniaRaportuModel();
    model.idLokalizacji = this.idLokalizacji;
    model.idProjektu = this.idProjektu;
    model.idPomieszczen = this.model.idPomieszczen;
    model.rodzajRaportu = this.model.rodzajRaportu;

    this.arkuszSpisuSerwis
      .pobierzDaneDoGenerowaniaRaportu(model)
      .subscribe((rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.adresLokalizacji = rezultat.element.adresLokalizacji;
          this.model.klient = rezultat.element.klient;
          this.model.lokalizacja = rezultat.element.adresLokalizacji;
          this.model.przewodniczacyZespolu =
            rezultat.element.przewodniczacyZespolu;
          this.model.spisRozpoczetoData = rezultat.element.spisRozpoczetoData;
          this.model.spisRozpoczetoGodzina =
            rezultat.element.spisRozpoczetoGodzina;
          this.model.spisZakonczonoData = rezultat.element.spisZakonczonoData;
          this.model.spisZakonczonoGodzina =
            rezultat.element.spisZakonczonoGodzina;
          this.model.uwagi = rezultat.element.uwagi;
          this.model.kolumny = rezultat.element.kolumny;
          // zapisane w projekcie szerokości traktujemy jak wpisane ręcznie
          this.szerokosciReczne = new Map(
            this.model.kolumny
              .filter((m) => m.szerokosc)
              .map((m) => [m.kolumna, m.szerokosc])
          );
          this.kolejnoscRecznych = Array.from(this.szerokosciReczne.keys());
          this.przeliczSzerokosci();
          this.czySpisSamodzielnyKlienta =
            rezultat.element.czySpisSamodzielnyKlienta;

          if (this.idPomieszczenia) {
            this.model.czyWywolanoZPoziomuPomieszczenia = true;
          }

          this.model.czyDrukowacMpkLokalizacji = true;

          // Inicjalizacja tablicy wykonawców spisu z jednym pustym elementem
          if (this.model.wykonawcySpisu.length === 0) {
            this.model.wykonawcySpisu.push('');
          }

          this.czyZaladowanoDane = true;
          return;
        }

        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      });
  }

  pobierzNazweRaportu() {
    switch (this.model.rodzajRaportu) {
      case RodzajRaportu.arkuszSpisu:
        return 'spisu';
      case RodzajRaportu.niedobory:
        return 'niedoborów';
      case RodzajRaportu.nadwyzki:
        return 'nadwyżek';
    }
  }

  generuj() {
    this.arkuszSpisuSerwis.generujRaport(this.model).subscribe((rezultat) => {
      if (this.czyRezultatOk(rezultat)) {
        this.bledyWalidacji = null;
        var a = document.createElement('a');
        a.target = '_blank';
        a.href = 'data:application/pdf;base64,' + rezultat.element.plik.plik;
        a.download = rezultat.element.plik.nazwaPliku;
        a.click();
        return;
      }
      if (this.bladModelu(rezultat)) {
        this.bledyWalidacji = rezultat.bledyModelu;
        return;
      }

      this.wyswietlKomunikat(rezultat.wiadomosc, true);
      return;
    });
  }

  anuluj() {
    if (this.idPomieszczenia) {
      this.router.navigate([
        this.miejsceWywolania,
        Routing.WyborRaportu,
        this.idProjektu,
        this.idLokalizacji,
        this.idPomieszczenia,
      ]);
    } else {
      this.router.navigate([
        this.miejsceWywolania,
        Routing.WyborRaportu,
        this.idProjektu,
        this.idLokalizacji,
      ]);
    }
  }

  pobierzAktywneKolumny() {
    return this.model.kolumny.filter((m) => m.czyWybrano);
  }

  czyKolumnaRecznie(kolumna: KolumnaDoRaportu) {
    return this.efektywneReczne.has(kolumna.kolumna);
  }

  sumaSzerokosci() {
    return this.pobierzAktywneKolumny().reduce(
      (suma, m) => suma + (m.szerokosc ?? 0),
      0
    );
  }

  zmienionoZaznaczenie(kolumna: KolumnaDoRaportu) {
    // zaznaczona kolumna z zapamiętaną szerokością odzyskuje ją z najwyższym priorytetem
    if (kolumna.czyWybrano && this.szerokosciReczne.has(kolumna.kolumna)) {
      this.przesunNaKoniec(kolumna.kolumna);
    }
    this.przeliczSzerokosci();
  }

  rozlozRowno() {
    this.szerokosciReczne.clear();
    this.kolejnoscRecznych = [];
    this.przeliczSzerokosci();
  }

  zapiszSzerokosci() {
    var model = new ZapiszSzerokosciKolumnModel();
    model.idProjektu = this.idProjektu;
    model.rodzajRaportu = this.model.rodzajRaportu;
    // zapisujemy tylko szerokości ustawione ręcznie, pozostałe kolumny przeliczą się przy wczytaniu
    model.kolumny = this.kolejnoscRecznych.map((nazwa) => ({
      kolumna: nazwa,
      czyWybrano: true,
      szerokosc: this.szerokosciReczne.get(nazwa),
    }));

    this.arkuszSpisuSerwis
      .zapiszSzerokosciKolumn(model)
      .subscribe((rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.bledyWalidacji = null;
          this.wyswietlKomunikat(
            model.kolumny.length > 0
              ? 'Zapisano szerokości kolumn'
              : 'Usunięto zapisane szerokości kolumn'
          );
          return;
        }
        if (this.bladModelu(rezultat)) {
          this.bledyWalidacji = rezultat.bledyModelu;
          return;
        }

        this.wyswietlKomunikat(rezultat.wiadomosc, true);
      });
  }

  zmienionoSzerokosc(kolumna: KolumnaDoRaportu) {
    var aktywne = this.pobierzAktywneKolumny();
    var wartosc = Math.round(Number(kolumna.szerokosc));

    if (aktywne.length > 1) {
      if (!kolumna.szerokosc || !Number.isFinite(wartosc)) {
        // puste pole lub 0 przywraca kolumnę do podziału automatycznego
        this.szerokosciReczne.delete(kolumna.kolumna);
        this.kolejnoscRecznych = this.kolejnoscRecznych.filter(
          (m) => m !== kolumna.kolumna
        );
      } else {
        // każda pozostała aktywna kolumna musi dostać co najmniej 1%
        this.szerokosciReczne.set(
          kolumna.kolumna,
          Math.min(Math.max(wartosc, 1), 100 - (aktywne.length - 1))
        );
        this.przesunNaKoniec(kolumna.kolumna);
      }
    }

    this.przeliczSzerokosci();
  }

  private przesunNaKoniec(nazwa: string) {
    this.kolejnoscRecznych = this.kolejnoscRecznych.filter((m) => m !== nazwa);
    this.kolejnoscRecznych.push(nazwa);
  }

  private przeliczSzerokosci() {
    var aktywne = this.pobierzAktywneKolumny();
    this.efektywneReczne.clear();
    this.model.kolumny
      .filter((m) => !m.czyWybrano)
      .forEach((m) => (m.szerokosc = null));

    if (aktywne.length === 0) {
      return;
    }

    // jedna kolumna zawsze zajmuje 100%, jej ręczna wartość zostaje zapamiętana na później
    if (aktywne.length === 1) {
      aktywne[0].szerokosc = 100;
      return;
    }

    // gdy ręczne wartości się nie mieszczą, najstarsze czasowo przechodzą do podziału automatycznego
    var nazwyAktywnych = aktywne.map((m) => m.kolumna);
    var reczne = this.kolejnoscRecznych.filter((m) => nazwyAktywnych.includes(m));
    var automatyczne: Array<KolumnaDoRaportu>;
    var pozostalo: number;
    while (true) {
      automatyczne = aktywne.filter((m) => !reczne.includes(m.kolumna));
      pozostalo =
        100 - reczne.reduce((suma, m) => suma + this.szerokosciReczne.get(m), 0);
      var czyPoprawne =
        automatyczne.length === 0
          ? pozostalo === 0
          : pozostalo >= automatyczne.length;
      if (czyPoprawne || reczne.length === 0) {
        break;
      }
      reczne.shift();
    }

    reczne.forEach((m) => this.efektywneReczne.add(m));
    aktywne
      .filter((m) => this.efektywneReczne.has(m.kolumna))
      .forEach((m) => (m.szerokosc = this.szerokosciReczne.get(m.kolumna)));

    if (automatyczne.length === 0) {
      return;
    }

    var bazowa = Math.floor(pozostalo / automatyczne.length);
    var reszta = pozostalo % automatyczne.length;
    automatyczne.forEach(
      (m, i) => (m.szerokosc = bazowa + (i < reszta ? 1 : 0))
    );
  }

  trackByIndex(index: number): number {
    return index;
  }

  dodajWykonawce() {
    this.model.wykonawcySpisu.push('');
  }

  usunWykonawce(index: number) {
    // Walidacja: minimum jeden wykonawca jest wymagany
    if (this.model.wykonawcySpisu.length > 1) {
      this.model.wykonawcySpisu.splice(index, 1);
    }
  }
}
